import { computed, reactive, type Ref } from 'vue'

export function useTextLimitController(text: Ref<string>) {
  const maxTextLength = import.meta.env.VITE_MAX_MESSAGE_SYMBOLS
  const isLengthLimitShown = computed(() => text.value.length >= maxTextLength / 2)
  const isLengthLimitWarningShown = computed(() => text.value.length >= maxTextLength)

  return reactive({
    maxTextLength,
    isLengthLimitShown,
    isLengthLimitWarningShown,
  })
}
